/**
 * Licensed Materials - Property of IBM
 * IBM Cognos Products: Dashboard
 * (C) Copyright IBM Corp. 2014, 2021
 * US Government Users Restricted Rights - Use, duplication or disclosure restricted by GSA ADP Schedule Contract with IBM Corp.
 */

define({
	'dlg_loading': 'Ladeoperation wird ausgeführt...',
	'dlg_close': 'Schließen',
	'dlg_ok': 'OK',
	'dlg_cancel': 'Abbrechen',
	'dlg_back': 'Zurück',
	'dlg_done': 'Fertig',

	// Slider
	'sliderRegionLabel': 'Schiebereglersteuerelement, mit dem Rechts- bzw. Linkspfeiltasten können Sie die Ziehpunkte des Schiebereglers bewegen.',
	'sliderHandleLabel': 'Ziehpunkt für Schieberegler',
	'a11ySliderHandleLabel': 'Ziehpunkt für Schieberegler %{sliderValue}',
	'sliderInputLabel': 'Wert',

	// Side bar
	'sidebarAdd': 'Hinzufügen',
	'clearTextFilterValue': 'Aufheben',
	'missingDataSetData': 'Die Daten für dieses Dataset sind nicht verfügbar. Aktualisieren Sie das Dataset oder wenden Sie sich an den Administrator, um Zugriff auf die Quelle zu erhalten.',

	// Toolbar
	'toolbarRegionLabel': 'Symbolleiste',
	'toolbarLabel': '%{labelName}:',
	'toolbarNoValueLabel': '%{labelName}',
	//TextToolbar
	'fontSelect': 'Schriftartengruppe',
	'fontSizeSelect': 'Schriftgröße',
	'fontColorSelect': 'Farbe',
	'fontStyle': 'Stil',
	'colorPickerTitle': 'Farbe auswählen',
	'bold': 'Fettdruck',
	'italic': 'Kursiv',
	'underline': 'Unterstrichen',
	'fontAlignment': 'Ausrichtung',
	'justifyLeft': 'Links ausrichten',
	'justifyCenter': 'Zentriert ausrichten',
	'justifyRight': 'Rechts ausrichten',
	'insertOrderedList': 'Geordnete Liste',
	'insertUnorderedList': 'Ungeordnete Liste',
	'fontColorPicker': 'Farbauswahl',
	'textWrap': 'Text umbrechen',
	'restore': 'Standardwerte wiederherstellen',
	// Top Bottom
	'topbottomNumberOfResultsLabel': 'Anzahl der Ergebnisse (%{lower} - %{higher})',
	'topbottomPercentLabel': 'Prozent (%{lower}% - %{higher}%)',
	'topbottomSelectOption': 'Option für obere oder untere Werte',
	'topbottomOptionLabel': 'Anzeigen',
	'searchByLabel': 'Nach',
	'searchNoMatches': 'Keine Übereinstimmungen gefunden',
	'topbottomRankColumnLabel': 'Rangfolgespalte zur Tabelle hinzufügen',
	'topbottomNone': 'Ohne',
	'topCount': 'Obere Werte',
	'topPercent': 'Obere %',
	'bottomCount': 'Untere Werte',
	'bottomPercent': 'Untere %',
	'searchColumn': 'Spalte suche',
	'searchColumnAriaLabel': 'Spalte suchen. Geben Sie den Namen der Spalte ein, nach der gesucht werden soll, und verwenden Sie den Abwärtspfeil, um die Spalte in einer Liste zu suchen.',
	'searchColumnQualifiedLabel': '%{columnLabel} (%{columnId})',
	'rankColumnLabel': 'Rangfolge (%{columnLabel})',
	'topbottomClearLabel': 'Zurücksetzen',

	// Format
	'formatAuto': 'Automatisch',
	'formatConvertPercent': 'Dezimalwerte in Prozentwerte konvertieren',
	'formatAbbreviate': 'Abkürzen',
	'formatUseGrouping': 'Tausendertrennzeichen verwenden',
	'dateStyle': 'Datumsstil',
	'dateTimeStyle': 'Stil für Datum/Uhrzeit',
	'formatMissingValueCharactersInfo': 'Mit \'Zeichen für fehlende Werte\' werden die Zeichen festgelegt, die anstelle von fehlenden Werten angezeigt werden sollen.',
	'currencySymbolLabel': 'Währungssymbol',
	'customSymbolPlaceholder': 'Symbol hinzufügen',
	'customSymbolLabelInfo': 'Gibt ein oder mehrere Zeichen an, die als benutzerdefiniertes Symbol verwendet werden sollen. Dieses Symbol wird der Zahl und gegebenenfalls dem Vorzeichen vorangestellt.',
	'numberLabel': 'Beschriftung für Zahl',
	'numberPositionLabel': 'Position der Beschriftung',
	'numberLabelInfo': 'Beschriftung für die formatierte Zahl, die abhängig von der festgelegten Position der Beschriftung als Präfix oder als Suffix hinzugefügt wird.',
	'nullValueDefault': '<Standardwert>',
	'nullValueContent': '(kein Wert)',
	'default': 'Standard',
	'beginning': 'Anfang',
	'end': 'Ende',
	'formatLabel': 'Format auswählen',

	// More data indicator
	'moreDataIndicator': 'Die Daten wurden nach %{threshold} Elementen abgeschnitten. Wenden Sie einen Filter an, um weniger Elemente anzuzeigen.',

	// Expanded View / Focus mode
	'evCollapse': 'Ausblenden',
	'duplicate': 'Duplizieren',
	'copyOf': 'Kopie von %{name}',
	'unableToDuplicateBoard': 'Duplizieren von "%{name}" nicht möglich.',

	// Widget list
	'errorLoadingWidgetList': 'Die Objekte können nicht geladen werden.',

	// Custom widgets
	'customWidget': 'Benutzerdefiniertes Widget'
});
